import React, { useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import YouTube from 'react-youtube';
import { Forward10Outlined, PauseCircleOutline, PlayCircleOutline, Replay10Outlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const VideoPlayer = () => {
  const [open, setOpen] = useState(false);
  const [t, i18next] = useTranslation("global")
  const language = localStorage.getItem('i18nextLng') || 'es'

  const playerRef = useRef(null);
  const buttonStyle = { color: '#7220DB', fontSize: '40px', cursor: 'pointer' }

  const onReady = (event) => {
    playerRef.current = event.target;
  };

  const handlePlay = () => {
    playerRef.current.playVideo();
  };

  const handlePause = () => {
    playerRef.current.pauseVideo();
  };

  const handleRewind = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(currentTime - 10);
  };

  const handleForward = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(currentTime + 10);
  };

  const handleEnded = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem('firtsVideDemo', 'true');
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            width: 'auto',
            maxWidth: 'none'
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {t('modals.videoDemo.gratitudeTitle')}
          <Divider />
        </DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-description">
            {t('modals.videoDemo.gratitude')}
            <br /> <br />
            <Typography variant="h6">
              <Link to={`/tutoriales`} style={{ color: '#ff6a13', textDecoration: "none", fontSize: "16px"  }} target="_blank" rel="noopener noreferrer">
                {t("modals.videoDemo.link")}
              </Link>
            </Typography>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            {t('modals.videoDemo.accept')}
          </Button>
        </DialogActions>
      </Dialog>

      <div>
        <YouTube
          videoId={language === 'es' ? "WpoxuvyYl4c" : "WpoxuvyYl4c"}
          opts={{ width: '800' }}
          onReady={onReady}
          onEnd={handleEnded}
        />
        <div>
          <PlayCircleOutline onClick={handlePlay} style={buttonStyle} />
          <PauseCircleOutline onClick={handlePause} style={buttonStyle} />
          <Replay10Outlined onClick={handleRewind} style={buttonStyle} />
          <Forward10Outlined onClick={handleForward} style={buttonStyle} />
        </div>
        <Typography variant="h6">
          <Link to={`/tutoriales`} style={{ color: '#ff6a13', textDecoration: "none", fontSize: "16px" }} target="_blank" rel="noopener noreferrer">
            {t("modals.videoDemo.link")}
          </Link>
        </Typography>
      </div>
    </>
  );
};

export default VideoPlayer;
